/// <reference path="holiday.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.Controls {
    class HolidayEditorController {

        static $inject = ["context", "holidayItem", "$filter", "$mdDialog"]
        public context: any;
        public holidayItem: any;
        public isAdding: boolean;
        public todayDate: Date;
        constructor(context: any, holidayItem: Model.Holiday, protected $filter: angular.IFilterService, private $mdDialog: angular.material.IDialogService) {
            this.context = context;
            this.isAdding = holidayItem === null || holidayItem === undefined;
            this.holidayItem = this.isAdding ? { displayName: "", holidayDate: moment().add(1, 'days').toDate(), id: 12, isCustom: true } : holidayItem;
            this.todayDate = moment().toDate();
        }

        apply = () => {
            if (this.isAdding) {
                if (this.context.addHoliday(this.holidayItem, null))
                    this.$mdDialog.hide();

            } else {
                if (!this.context.holidayDateValidator(this.holidayItem)) {
                    return;
                }
                this.$mdDialog.hide();
            }
        }
        cancel = () => {
            this.$mdDialog.hide();
        }
    }

    angular.module("meevo.plugins.holiday")
    .controller("meevo.plugins.HolidayEditorController", HolidayEditorController);
}